// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__siYLU","wrapper":"Navbar_wrapper__w-U3W","select-wrapper":"Navbar_select-wrapper__rUlm2","fadeIn":"Navbar_fadeIn__b-GfR","fadeOut":"Navbar_fadeOut__0BrgZ"};